module.exports = __webpack_public_path__ + "static/img/11.f59aa41.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/eng/11.png
// module id = jdsl
// module chunks = 0